module.exports = __webpack_public_path__ + "img/FK.012a72af.png";